import styled from 'styled-components/macro'
import { squircle } from 'src/global/helpers'

export const Wrapper = styled.div`
  min-height: 100vh;
  padding: 32px 16px 48px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 768px) {
    padding: 24px 12px 32px;
  }
`

export const Article = styled.article`
  max-width: 760px;
  width: 100%;

  .page-question {
    margin-left: auto;
    margin-right: auto;
    color: ${props => props.theme.normalText};
  }
`

export const Content = styled.div`
  .contact-methods {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
    gap: 16px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 14px;
    }
  }

  .contact-panel {
    position: relative;
    width: auto;
    max-width: none;
    min-height: 216px;
    ${squircle(32)}
    padding: 22px;
    overflow: hidden;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 14px;

    &.featured {
      grid-column: span 2;
      justify-self: center;
      width: 100%;
      max-width: 420px;
      background: linear-gradient(135deg, #f2a14b 0%, #ff8b4d 65%, #ff7a50 100%);
      box-shadow: 0 8px 24px rgba(255, 122, 80, 0.22), 0 2px 6px rgba(255, 139, 77, 0.18);

      @media (max-width: 768px) {
        grid-column: span 1;
      }
    }

    &.email {
      background: linear-gradient(135deg, #64748b 0%, #475569 60%, #334155 100%);
      box-shadow: 0 8px 24px rgba(51, 65, 85, 0.25), 0 2px 6px rgba(71, 85, 105, 0.18);
    }

    &.messenger {
      background: linear-gradient(135deg, #00b2ff 0%, #006aff 45%, #a033ff 100%);
      box-shadow: 0 8px 24px rgba(0, 106, 255, 0.25), 0 2px 6px rgba(160, 51, 255, 0.2);
    }

    &.phone {
      background: linear-gradient(135deg, #7ac943 0%, #4ec48b 60%, #32bd98 100%);
      box-shadow: 0 8px 24px rgba(78, 196, 139, 0.22), 0 2px 6px rgba(50, 189, 152, 0.18);
    }

    &.onboarding {
      cursor: pointer;
      background: linear-gradient(20deg, hsl(206deg 100% 50%), hsl(192deg 98% 52%));
      box-shadow: 0 8px 24px rgba(17, 183, 243, 0.22), 0 2px 6px rgba(17, 183, 243, 0.18);
    }

    .panel-head {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .icon-tile {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 18px;

      svg {
        display: block;
      }
    }

    h3.title {
      margin: 0;
      max-width: none;
      font-size: 18px;
      font-weight: 700;
      line-height: 1.25;
      color: #ffffff;
      text-align: left;
    }

    .description {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.45;
      color: rgba(255, 255, 255, 0.92);
      text-align: left;
    }

    .value-text {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      text-decoration: none;
      letter-spacing: -0.01em;
      word-break: break-all;
      align-self: flex-start;
    }

    .value-pill {
      align-self: flex-start;
      max-width: 100%;
      padding: 8px 14px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 999px;
      corner-shape: squircle;
      font-size: 14px;
      font-weight: 600;
      color: #ffffff;
      text-decoration: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .schedule {
      position: absolute;
      top: 18px;
      right: 18px;
      padding: 6px 12px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid rgba(255, 255, 255, 0.32);
      border-radius: 999px;
      corner-shape: squircle;
      backdrop-filter: blur(8px);
      font-size: 11px;
      font-weight: 600;
      color: #ffffff;
      letter-spacing: 0.01em;
      white-space: nowrap;
    }

    .cta {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 12px 16px;
      background: rgba(255, 255, 255, 0.22);
      border: 1px solid rgba(255, 255, 255, 0.35);
      ${squircle(40)}
      font-size: 14px;
      font-weight: 600;
      color: #ffffff;
      text-decoration: none;
      cursor: pointer;
      transition: background 0.2s ease, transform 0.2s ease;
      margin-top: auto;

      svg {
        font-size: 13px;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.32);
      }

      &:active {
        transform: scale(0.98);
      }
    }
  }

  .main-site-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 28px;
    color: ${props => props.theme.normalText};
    opacity: 0.45;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-decoration: none;
    transition: opacity 0.2s ease;

    svg {
      font-size: 12px;
    }

    &:hover {
      opacity: 0.85;
    }
  }
`
